import React from 'react';
import NewTabLink from '@sls-react/components/Links/NewTabLink';

const helpLinks = {
  affiliates: 'https://help.sidelineswap.com/hc/en-us/articles/360016976000',
  ambassadors: '/ambassador/apply',
  badges: '/help/badges',
  buyerProtection: '/help/buyer-protection',
  buying: '/help/buying',
  canadianCashout:
    'https://help.sidelineswap.com/selling/cashing-out/if-i-have-a-canadian-bank-account-how-i-do-cash-out-in-usd',
  cashOutTiming: '/help/cash-out-timing',
  changeEmail:
    'https://help.sidelineswap.com/hc/en-us/articles/360010496320-How-to-Change-My-Email-Address-or-Username',
  communityGuidelines: '/help/community-guidelines',
  contactUs: '/help/contact-us',
  countryResidence: '/help/country-residence',
  default: '/help',
  donate: 'https://sell.sidelineswap.com/donate/',
  eliteSeller:
    'https://help.sidelineswap.com/hc/en-us/articles/360010255880--Elite-Seller-Program',
  howDoIGetPaid: '/help/how-do-i-get-paid',
  howToTrade: '/help/how-to-trade',
  ims: 'https://help.sidelineswap.com/hc/en-us/articles/4412819019922',
  myFeed: '/help/my-feed',
  press: '/help/press',
  productRankings:
    'https://help.sidelineswap.com/hc/en-us/articles/4402828329106',
  prohibitedItems: '/help/prohibited-items',
  refundPolicy: '/help/refund-policy',
  refundRateImportance:
    'https://help.sidelineswap.com/hc/en-us/articles/360013927139',
  safety: '/help/safety',
  sales: '/help/sales',
  selling: '/help/selling',
  shipping: '/help/shipping',
  shippingRegions: '/help/shipping-regions',
  sidelineProtection: '/help/sidelineswap-protection',
  signIn: '/help/sign-in',
  supportedDevices: '/help/supported-devices',
  underReview: '/help/under-review',
  unrestrictForm:
    'https://help.sidelineswap.com/hc/en-us/requests/new?ticket_form_id=360000525400',
  whatAreTheFees: '/help/what-are-the-fees',
  whySsn: '/help/ssn-photo-id',
  w9: 'https://help.sidelineswap.com/hc/en-us/articles/360010269400-1099-K-Forms-for-Sellers',
};

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  link?: keyof typeof helpLinks;
};

const HelpLink: React.FC<Props> = ({
  children,
  link = 'default',
  ...props
}) => (
  <NewTabLink {...props} href={helpLinks[link]} rel="nofollow noindex">
    {children}
  </NewTabLink>
);

export default HelpLink;
